import Choices from 'choices.js'
// import 'choices.js/public/assets/styles/choices.css'

document.addEventListener('turbo:load', () => {
  const selects = document.querySelectorAll('.choices-select')
  selects.forEach(select => {
    const choices = new Choices(select, {addChoices: true, removeItemButton: true})

    // Focus search field when dropdown opens
    choices.passedElement.element.addEventListener('showDropdown', () => {
      if (choices.input) {
        const searchInput = choices.input.element
        setTimeout(() => {
          searchInput.focus()
        }, 0)
      }
    })
  })
})

